import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

export function RenderContent(title: string, content: string[] = []) {
	return (
		<S.ContentContainer>
			<S.ContentTitle>{title}</S.ContentTitle>
			{content.length > 0 ? (
				content.map((item: string) => <S.ContentTag key={item}>{item}</S.ContentTag>)
			) : (
				<p>{I18n.get('No content available')}</p>
			)}
		</S.ContentContainer>
	);
}
